import { render, staticRenderFns } from "./InfoInstitucional.vue?vue&type=template&id=692a4c3b&"
import script from "./InfoInstitucional.vue?vue&type=script&lang=js&"
export * from "./InfoInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports